<template>
  <div class="paySupport">
    <div class="screen">
      <!-- <router-link :to="{ path: '/apply/GoodsGroup/4/createGroup' }"> -->
      <h2>支付项选择</h2>
      <!-- </router-link> -->
    </div>
    <template>
      <div class="tables">
        <template>
          <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="title" label="支付名称" min-width="140"></el-table-column>
            <el-table-column label="是否开启" min-width="140">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.state"
                  active-color="#13ce66"
                  inactive-color="#ff4949">
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      
      tableData: [
        {
          title: "与商储卡共同使用",
          state: false
        },
        {
          title: "与乐通卡共同使用",
          state: true
        },
        {
          title: "与优惠券共同使用",
          state: true
        }
      ],
      value: ""
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.paySupport {
  width: 100%;
  padding: 15px 25px;
  padding-right: 200px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .el-select {
    width: 100px;
  }
  .screen {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 25px;
    .el-button,
    .el-select,
    .el-input {
      margin-right: 10px;
    }
    .el-input {
      width: 200px;
    }
  }
  .tables {
    width: 100%;
    border: 1px solid #ebeef5;
  }
  .success {
    width: 100%;
  }
}
</style>

<style lang="scss">
.paySupport {
  .cell {
    text-align: center;
  }
}
</style>
